export type ColorPickerSwatchInput = string | { value: string; label?: string };

export function resolveSwatch(input: ColorPickerSwatchInput): {
  value: string;
  label?: string;
} {
  return typeof input === "string" ? { value: input } : input;
}
